module.exports = __webpack_public_path__ + "img/logo.eb0a1bab.png";